export default {
  Title: 'List of Requests',
  Domain: 'Domain',
  Types: 'Types',
  Source: 'Source',
  SaleRevenue: 'Sales Revenue',
  PartnerProceeds: 'Partner Proceeds',
  MisaProceeds: 'MISA Proceeds',
  Upgrade: 'Upgrade',
  Extend: 'Extend',
  PurchaseDevice: 'Purchase devices',
  NeedApproval: 'Need Approval',
  Rejected: 'Rejected',
  Approved: 'Approved',
  By: 'by ',
  Approve: 'Approve',
  Edit: 'Edit',
  Delete: 'Delete',
  Search: 'Search',
  Filter: 'Filter',
  Type: 'Type',
  PurchaseExtraDevices: 'Purchase extra devices',
  Status: 'Status',
  All: 'All',
  DateCreated: 'Request date',
  MerchantID: 'MID',
  Createby: 'Created by',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Apply: 'Apply',
  Total: 'Total: {number} requests',
  TotalRange: 'requests',
  ApproveRequest: 'Approved Request',
  ApproveRequestText: 'Are you sure you want to approve this request?',
  Success: 'Update successfully',
  SuccessFail: 'Update failed',
  OtherReason: 'Orther reasons',
  AcceptDelete: 'Are you sure delete this request?',
  Failed: 'An error occurred, please try again',
  Partner: 'Partner',
  DeleteSuccess: 'Delete successfully',
  RequestNewBranch: 'New branch',
  AutoExtend: 'Auto extend',
  UnknownType: 'Unknown type',
  NumberOfBranchPurchasing: 'Number of additional branches purchasing',
  BranchList: 'Branch list',
  BranchName: 'Branch name',
  BranchNameMaxLength: 'Branch name must be less than 100 characters',
  SelectPackage: 'Select package',
  STT: 'No.',
  Package: 'Package',
  BranchQuantityMustBeGreaterThan0: 'Branch quantity must be greater than 0',
  BranchQuantityMustBeLessThan50: 'Branch quantity must be less than 50',
  ConfirmCreateBranch: 'Are you sure you want to create these branches?',
  ConfirmUpgradeBranch: 'Are you sure you want to upgrade branches?',
  ConfirmExtendBranch: 'Are you sure you want to extend branches?',
  Save: 'Save',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  PleaseSelectPackageForBranch: 'Please select package for branch {branch_name}',
  CreationDate: 'Created date',
  StartDate: 'Start date',
  EndDate: 'End date',
  Status: 'Status',
  NumberOfPOS: 'Number of POS',
  NumberOfExtraPOS: 'Number of Extra POS',
  NumberOfExtraKiosk: 'Number of Extra Kiosk',
  NumberOfExtraTablet: 'Number of Extra Tablet/Handheld',
  OrderValue: 'Order value',
  DeviceList: 'List of devices',
  ListOfRequest: 'List of request',
  Total: 'Total: {number} requests',
  CrmOrderId: 'CRM ID',
  CrmOrderInformation: 'Thông tin đơn hàng CRM',
  CrmCreateOrderFailed: 'Failed to create order on CRM. Reason: {reason}',
  Resend: 'Resend',
  ResendSuccess: 'Order re-sent to CRM successfully.',
  ResendFailed: 'Failed to re-send order to CRM. Reason: {reason}',
  ExtraNMonths: 'Extra {n} months',
  Discount: 'Discount',
  DiscountType: 'Discount type',
  DiscountPercent: 'Percent',
  DiscountFlatAmount: 'Flat amount',
  AddRow: 'Add row',
  AutoCreateOrder: 'Tự động tạo đơn hàng',
  AutoCreateRequest: 'Auto-create request',
  ImsRequestId: 'IMS ID',
  ResendIms: 'Resend IMS',
  ImsCreateRequestFailed: 'Failed to create request on IMS. Reason: {reason}',
  ImsResendSuccess: 'Request re-sent to IMS successfully.',
  ImsResendFailed: 'Failed to re-send request to IMS. Reason: {reason}',
  ImsRequestInformation: 'IMS Request Information',
  ImsProduct: 'Product',
  ImsRequestType: 'Request type',
  ImsRequestTypeNew: 'New sale',
  ImsRequestTypeRenewal: 'Renewal',
  ImsRequestTypeFree: 'Free',
  ImsPackageTrial: 'Trial',
  ImsPackageStarter: 'Starter',
  ImsPackageStandard: 'Standard',
  ImsPackageAdvanced: 'Advanced',
  ImsPackageProfessional: 'Professional',
  ImsPackageEnterprise: 'Enterprise',
  ImsAccessAddress: 'Access address',
  ImsStartDate: 'Start date',
  ImsDuration: 'Duration (months)',
  ImsExpiryDate: 'Expiry date',
  ImsAmount: 'Amount',
  ImsDescription: 'Description',
  ImsBranchCount: 'Number of branches',
  ImsSubscriptionInformation: 'Subscription information',
  ImsCustomerInformation: 'Customer information',
  ImsCustomer: 'Customer',
  ImsAgencyCode: 'Agency code',
  ImsSalesProject: 'Sales project',
  ImsContact: 'Contact person',
  ImsContactTitle: 'Title',
  ImsContactPrefix: 'Salutation',
  ImsPhone: 'Phone',
  ImsEmail: 'Email',
  ImsCountry: 'Country',
  ImsAddress: 'Address',
  ImsSubscriptionCode: 'Subscription code',
  ImsPackage: 'Package',
  ImsEndDate: 'End date',
  ImsSelfOrderingKiosk: 'Self-ordering KIOSK',
  ImsOnlineReservation: 'Online Reservation',
  ImsOrderOnline: 'Order online',
  ImsOrderAtTable: 'Order at table',
  ImsLomas: 'Lomas',
  ImsDeviceBusinessInformation: 'Device & business information',
  ImsDeviceTab: 'Devices',
  ImsBusinessTab: 'Business/Features',
  ImsDeviceType: 'Device type',
  ImsPurchaseQuantity: 'Purchase quantity',
  ImsBusinessType: 'Business/Feature type',
  ImsAddRow: 'Add row',
  ImsDeleteRow: 'Delete row',
  ImsContactRequired: 'Contact person is required.',
  ImsPhoneRequired: 'Phone number is required.',
  ImsPhoneInvalid: 'Phone number may contain only digits, spaces, hyphens, plus signs, and parentheses.',
  ImsEmailRequired: 'Email is required.',
  SaleOrderDateRequired: 'Order date is required',
  AccountRequired: 'Customer is required',
  SaleOrderAmountOCRequired: 'Foreign order amount is required',
  SaleOrderAmountRequired: 'Order amount is required',
  DueDateRequired: 'Due date is required',
  StatusRequired: 'Status is required',
  ProductCodeRequired: 'Product code is required',
  PriceRequired: 'Price is required',
  ToCurrencyOCRequired: 'Foreign total is required',
  ToCurrencyRequired: 'Total is required',
  ExchangeRateInvalid: 'Exchange rate must be greater than zero',
  Date: 'Date',
  Action: 'Action',
  NumberOfTablet: 'Number of Tablet/Handhelds',
  NumberOfKiosk: 'Number of Kiosk',
  Creator: 'Created by',
  Approver: 'Approved by',
  DeviceType: 'Device type',
  Quantity: 'Quantity',
  DeviceStartDate: 'Start date',
  DeviceEndDate: 'End date',
  // Chart translations
  TotalRevenue: 'Total revenue',
  PartnerPayout: 'Partner amount',
  NetRevenue: 'Net revenue',
  TotalLicenses: 'Total licenses',
  NewRegistration: 'New registration',
  NewActivation: 'New activation',
  NoData: 'No data',
  Loading: 'Loading...',
  RevenueTooltip: '{label}: {value}',
  LicenseTooltip: '{label}: {value}',
  // Time range options
  ThisMonth: 'This month',
  Today: 'Today',
  ThisWeek: 'This week',
  LastMonth: 'Last month',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  ThisQuarter: 'This quarter',
  LastQuarter: 'Last quarter',
  Quarter1: 'Quarter 1',
  Quarter2: 'Quarter 2',
  Quarter3: 'Quarter 3',
  Quarter4: 'Quarter 4',
  ThisYear: 'This year',
  LastYear: 'Last year',
  ComparedToPrevious: 'Compared to previous period',
  ComparedToSamePeriodLastYear: 'Compared to same period last year',
  // Dashboard KPI Headers
  NetRevenue: 'Net revenue',
  TotalLicenses: 'Total licenses',
  NewRegistration: 'New registration',
  SoftwareUsageRate: 'Software usage rate',
  NewActivation: 'New activation',
  LicenseActivationRate: 'License activation rate',
  LicensesAboutToExpire: 'Licenses about to expire',
  RenewalRate: 'Renewal rate',
  // Component Titles
  ExtraDevicesAddOnFeatures: 'Extra devices/Add-on features',
  LicensesByPackage: 'Licenses by Package',
  NetRevenueByPartner: 'Net revenue by partner',
  RevenueBySalesperson: 'Revenue by salesperson',
  // Table Headers
  Partner: 'Partner',
  Country: 'Country',
  NewLicensesThis: 'New licenses (This)',
  NewlyActivatedLicenses: 'Newly activated licenses',
  ActivatedRate: 'Activated rate',
  ExpiringLicenses: 'Expiring licenses',
  RenewedLicenses: 'Renewed licenses',
  RenewalRateTable: 'Renewal rate',
  SoftwareUsageRateTable: 'Software usage rate',
  Revenue: 'Revenue',
  Salesperson: 'Salesperson',
  SearchPartner: 'Search partner...',
  // General
  All: 'All',
  AllPartners: 'All Partners',
  // Messages
  NoPartnerData: 'No partner data available',
  NoPartnersMatch: 'No partners match your search',
  NoRevenueData: 'No revenue data available',
  NoDataAvailable: 'No data available',

  // Tooltip messages
  SoftwareUsageRateTooltip: 'Active domains / Total domains',
  LicenseActivationTooltip: '{activated}/{total} domain activated',
  RenewalRateTooltip: '{renewed}/{total} domain extended',
  IncludePackage: 'Include package',
  Extra: 'Extra',

  // Bổ sung cho RequestList/RequestDetail/Branch popups (gộp từ hardcode + i18nAccountingObject.Common/CreateRequest + i18nLicense)
  NoLicenseData: 'No matching data found',
  ResetToPartnerCountry: 'Reset to Partner country',
  WrongCountrySelected: 'No license data for this country. Your Partner operates in only one specific country.',
  Ok: 'OK',
  Mode: 'Mode',
  Live: 'Live',
  Demo: 'Demo',
  Unknown: 'Unknown',
  Version: 'Version',
  Version1: 'Version 1 (W&D)',
  Version2: 'Version 2 (Android)',
  Export: 'Export',
  ExportPDF: 'Export PDF',
  ExportExcel: 'Export Excel',
  System: 'System',
  ListOfRequestData: 'List of request data_',
  EmptyPackage: 'Package cannot be blank',
  ExchangeRate: 'Exchange rate (VND)',
  EmptyExchangeRate: 'Exchange rate cannot be blank',
  PartnerCommission: 'Partner Commission ({percent}%)',
  ResetToDefaultRate: 'Reset to default exchange rate',
  Reject: 'Reject',
  RejectTitle: 'Reject Request',
  RejectDescription: 'Are you sure want to reject this request?',
  RejectReason: 'Enter reason to reject...',
  RejectEmptyReason: 'Reason reject cannot be blank',
  ChosenProductPackage: 'Chosen product package',
  ViewLicenseInfo: 'View license info',
  Unit: 'Unit',
  Qty: 'Qty.',
  UnitPrice: 'Unit price',
  Subtotal: 'Subtotal',
  InputValueMustBeGreaterThan0: 'Input value must be >= 0',
  Year: 'Year',
  Month: 'Month',
  ExtraDevices: 'Extra devices',
  ApplyAllProductPackages: 'Apply all product packages',
  POS: 'POS',
  TabletsHandhelds: 'Tablets/Handhelds',
  Kiosk: 'Kiosk',
  AddOnFeatures: 'Add-on features',
  NotePlaceholder: 'Your note goes here...',
  PackageName: 'Package name',
  ExtraPOSDevice: 'Extra POS device',
  ExtraTabletsHandheldsDevice: 'Extra Tablets/Handhelds device',
  ExtraKioskDevice: 'Extra Kiosk device',
  ExpiryTime: 'Expiry time',
  Payment: 'Payment',
  Promotion: 'Promotion (',
  NetSales: 'Net Sales',
  MISAAmount: "MISA's amount",
  NewBranch: 'New branch',
  ConfirmCreateRequest: 'Are you sure you want to create this request?',
  ConfirmCreateRequestNewLicense: 'Are you sure you want to request new branch?',
  NotifyNewBranchUpdate: 'Are you sure you want to update this new branch request?',
  NotifyUpdate: 'Are you sure you want to extend this license?',
  PurchaseUpdate: 'Are you sure you want to purchase this license?',
  UpgradeUpdate: 'Are you sure you want to upgrade this license?',
  CreateRequestTitle: 'Create request',
  UpdateRequestTitle: 'Update request',
  ApproveRequestTitle: 'Approve request',
  CreateSuccess: 'Create request successfully',
  CreateFail: 'Create request failed',
  UpdateSuccess: 'Update request successfully',
  UpdateFail: 'Update request failed',
  ApproveSuccess: 'Approve request successfully',
  ApproveFail: 'Approve request failed',
  RejectSuccess: 'Reject request successfully',
  RejectFail: 'Reject request failed',
  ApproveUpdate: 'Are you sure you want to approve this request?',
  ExtraMonthWarning: 'Extra months cannot more than duration months',
  ExtraMonthPartnerWarning: 'Extra months cannot more than 3 months',
  ExtendBranches: 'Extend branches',
  UpgradeBranches: 'Upgrade branches',
  CreateBranch: 'Request new branch',
  QuantityMustNotExceed: 'Quantity must not exceed {maxQty} for {branch_name}',
  PleaseEnterValidQuantity: 'Please enter a valid quantity for {branch_name}',
  BranchNumber: 'Branch {number}',
  Note: 'Note',
  TotalLabel: 'Total',
  Required: 'This field is required',
  CrmGeneralInformation: 'I. Thông tin chung',
  CrmCurrencyInformation: 'Currency information',
  CrmProductInformation: 'Product information',
  CrmOrderExecutionStatus: 'Order execution status',
  CrmInvoiceInformation: 'Invoice information',
  CrmDescriptionInformation: 'Description information',
  CrmSystemInformation: 'System information',
  LiquidateAmountOC: 'Liquidation value (FC)',
  LiquidateAmount: 'Liquidation value',
  SaleOrderType: 'Order type',
  UseCurrency: 'Use foreign currency',
  CurrencyType: 'Currency',
  RecordDate: 'Revenue recording date',
  InvoiceCustomer: 'Invoice customer',
  Address: 'Address',
  SystemDescription: 'Description',
  Owner: 'Owner',
  OwnerRole: 'Owner role',
  SalesEmployee: 'Sales employee',
  SalesUnit: 'Sales unit',
  Unit: 'Unit',
  Amount: 'Quantity',
  UnitIDText: 'Unit',
  ToCurrency: 'Amount',
  TotalAfterPromotion: 'Total after promotion',
  DiscountOC: 'Discount (FC)',
  ToCurrencyOCAfterDiscount: 'Amount after discount (FC)',
  ToCurrencyAfterDiscount: 'Amount after discount',
  TaxPercent: 'Tax rate',
  TaxOC: 'Tax (FC)',
  QuantityByUnit: 'Quantity by unit',
  TaxAmount: 'Tax amount',
  UnitPriceByUnit: 'Unit price by unit',
  TotalOC: 'Total (FC)',
  OrderNumber: 'Order number',
  SaleOrderDate: 'Order date',
  Account: 'Customer',
  OrderValueOC: 'Order value (FC)',
  DueDate: 'Due date',
  Description: 'Description',
  ParentOrder: 'Parent order',
  PartnerType: 'Partner type',
  ProductCode: 'Product code',
  RevenueStatus: 'Revenue status',
  DeliveryStatus: 'Delivery status',
  CreatedBy: 'Created by',
  Activated: 'Activated',
  ToCurrencyOC: 'Amount (FC)',
  UnitPriceAfterDiscount: 'Unit price after discount',
  CrmSaleOrderTypeNew: 'New sale',
  CrmSaleOrderTypeExtra: 'Extra sale',
  CrmSaleOrderTypeUpgrade: 'Upgrade',
  CrmSaleOrderTypeRenew: 'Renew/Update',
  CrmSaleOrderTypeTraining: 'Training service',
  CrmSaleOrderTypeConsulting: 'Implementation consulting',
  CrmSaleOrderTypeOther: 'Other service',
  CrmPartnerTypeNew: 'New partner',
  CrmPartnerTypeExisting: 'Existing partner',
  CrmStatusNotExecuted: 'Not executed',
  CrmRevenueStatusDraft: 'Draft',
  CrmRevenueStatusRequested: 'Requested to record',
  CrmDeliveryStatusNotDelivered: 'Not delivered',
};
